import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UiChartCircularProgressBarComponent } from '@big-direkt/ui/chart';
import { TranslocoDirective } from '@jsverse/transloco';
import { UiCardStatusModel } from './card-status.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'big-ui-card-status',
    templateUrl: './card-status.component.html',
    imports: [NgClass, DatePipe, UiChartCircularProgressBarComponent, TranslocoDirective],
})
export class CardStatusComponent {
    @Input() public data!: UiCardStatusModel;
}
